import React from 'react';

import FieldPhone from '../common/FieldPhone';
import FieldText from '../common/FieldText';
import FieldNumber from '../common/FieldNumber';
import FieldTextArea from '../common/FieldTextArea';
import FieldSelect from '../common/FieldSelect';
import FieldMultiSelect from '../common/FieldMultiSelect';

class PropertyOtherDetails extends React.Component {
  render() {
    const fields = this.props.model.fields;
    const property = this.props.property;
    const onValueChange = this.props.onValueChange;
    const inValid = this.props.inValid;
    return (
      <>
        <div className="formhead col-md-12"><h2>Property Other Details</h2></div>
        
        <FieldPhone key="phone" id="phone" field={fields.phone}
          value={property.phone} onValueChange={onValueChange} inValid={inValid} /> 
        
        <FieldMultiSelect key="amenities" id="amenities"  field={fields.amenities} 
          value={property.amenities} onValueChange={onValueChange} inValid={inValid} />

        <FieldSelect key="total_bathroom" id="total_bathroom" field={fields.total_bathroom}
          value={property.total_bathroom} onValueChange={onValueChange} inValid={inValid} />

        <FieldSelect key="total_balconies" id="total_balconies" field={fields.total_balconies}
          value={property.total_balconies} onValueChange={onValueChange} inValid={inValid} />

        <FieldSelect key="water_supply" id="water_supply" field={fields.water_supply}
          value={property.water_supply} onValueChange={onValueChange} inValid={inValid} />

        <FieldSelect key="neighbourhood" id="neighbourhood" field={fields.neighbourhood}
          value={property.neighbourhood} onValueChange={onValueChange} inValid={inValid} />
        
        <FieldSelect key="furnishing" id="furnishing" field={fields.furnishing}
          value={property.furnishing} onValueChange={onValueChange} inValid={inValid} />

        <FieldSelect key="parking_option" id="parking_option" field={fields.parking_option}
          value={property.parking_option} onValueChange={onValueChange} inValid={inValid} />

        <FieldSelect key="oc_received" id="oc_received" field={fields.oc_received}
          value={property.oc_received} onValueChange={onValueChange} inValid={inValid} />

        <FieldSelect key="facing" id="facing" field={fields.facing}
          value={property.facing} onValueChange={onValueChange} inValid={inValid} />

        <FieldNumber key="property_age" id="property_age" field={fields.property_age}
          value={property.property_age} onValueChange={onValueChange} inValid={inValid} />     

        <FieldNumber key="num_of_tower" id="num_of_tower" field={fields.num_of_tower}
          value={property.num_of_tower} onValueChange={onValueChange} inValid={inValid} /> 

        <FieldText key="wing" id="wing" field={fields.wing}
          value={property.wing} onValueChange={onValueChange} inValid={inValid} /> 

        <FieldNumber key="floor" id="floor" field={fields.floor}
          value={property.floor} onValueChange={onValueChange} inValid={inValid} />

        <FieldNumber key="of" id="of" field={fields.of}
          value={property.of} onValueChange={onValueChange} inValid={inValid} />

        <FieldMultiSelect key="area" id="area"
          field={fields.area} value={property.area} onValueChange={onValueChange} inValid={inValid} />

        <FieldTextArea key="description" id="description" field={fields.description}
          value={property.description} onValueChange={onValueChange} inValid={inValid} />
      </>
    );
  }
}

export default PropertyOtherDetails;